<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Loyer moyen</h2>
        </div>
    </div>
    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/ss_loyer_moyen.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-12 text-center">
                <div class="row">
                    <div class="col-12 col-md-4 text-center">
                        <mat-form-field [ngClass]="{'no_plan' : !authenticationService.isAllowed('basique')}">
                            <mat-label>Exploitation</mat-label>
                            <mat-select disableOptionCentering #selectFurnish [(ngModel)]="furnish"
                                        (ngModelChange)="edit($event, 'furnish')">
                                <mat-option [value]="0">Tous confondu</mat-option>
                                <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 1)" [value]="1">
                                    Meublé
                                </mat-option>
                                <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 2)" [value]="2">Nu
                                </mat-option>
                                <mat-option [value]="4">Colocation
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-12 col-md-8 text-center">
                        <mat-form-field *ngIf="furnish == 0 || furnish == 1 || furnish == 2">
                            <mat-label>Simulation de loyer à {{ favorite.ad_city.name }}</mat-label>
                            <mat-select disableOptionCentering [(ngModel)]="advice_rent_choice" (ngModelChange)="edit($event)">
                                <mat-optgroup *ngFor="let group of rentChoice | keyvalue: adService.sortGeneralFirst"
                                              [label]="group.key">
                                    <mat-option *ngFor="let value of group.value | keyvalue"
                                                [disabled]="value.value == undefined || value.value.x0 == 0"
                                                [value]="value.key">{{cityService.rentFields[value.key].lib}}</mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <div class="data_moy">
                    <h3 class="text-center">
                        Estimations de loyer
                        <ng-container *ngIf="furnish == 4">
                            pour {{ favorite.rooms > 2 ? (favorite.rooms - 1) + ' chambres' : 'une chambre' }}
                        </ng-container>
                        <i *ngIf="cityService.rentFields[advice_rent_choice] && (furnish == 0 || furnish == 1 || furnish == 2)" class="fa fa-info-circle"
                           matTooltip="Estimation basée sur un logement {{ cityService.rentFields[advice_rent_choice].lib }} de {{ displaySquare }}m² en location à {{ favorite.ad_city.name }}
Si une option n’est pas cliquable, cela signifie qu’il n’y a pas suffisamment d’annonces de location à {{ favorite.ad_city.name }} afin d’avoir des estimations fiables."></i>
                        <i *ngIf="advice_rent_choice && furnish == 4" class="fa fa-info-circle"
                           matTooltip="Estimation basée sur {{ favorite.rooms > 2 ? (favorite.rooms - 1) + ' chambres' : 'une chambre' }} en colocation à {{ favorite.ad_city.name }}
Si une option n’est pas cliquable, cela signifie qu’il n’y a pas suffisamment d’annonces de location à {{ favorite.ad_city.name }} afin d’avoir des estimations fiables."></i>
                    </h3>
                    <div class="row justify-content-center">
                        <div class="wrap">
                            <div class="row">
                                <div class="col-6 moy_price">
                                    <label>
                                        Moyen <i class="fa fa-info-circle"
                                                 matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte). Il s’agit du loyer médian : 50% des logements similaires ont un loyer plus faible, et 50% ont un loyer plus élevé."></i>
                                    </label>
                                    <b class="value">
                                        {{ advice_rent | number:'1.0-0' }}
                                        <span class="unit"> €</span>
                                    </b>
                                </div>
                                <div class="col-6 range_price">
                                    <label>
                                        Bas <i class="fa fa-info-circle"
                                               matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte). Il s’agit du loyer bas : 25% des logements similaires ont un loyer plus faible, et 75% ont un loyer plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ advice_rent_L | number:'1.0-0' }}
                                        <span class="unit"> €</span>
                                    </b>
                                    <br/>
                                    <label>
                                        Haut <i class="fa fa-info-circle"
                                                matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte). Il s’agit du loyer haut : 75% des logements similaires ont un loyer plus faible, et 25% ont un loyer plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ advice_rent_U | number:'1.0-0' }}
                                        <span class="unit"> €</span>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center confidence">
                        Indice de confiance
                        <i class="fa fa-circle{{ advice_rent_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_rent_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_rent_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_rent_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_rent_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                    </div>
                </div>
            </div>

            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
    </div>

    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/ss_loyer_moyen.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <hr/>
            <div echarts [options]="optionsNewrent" [merge]="dataNewrent" class="chart"
                 (chartInit)="onNewChartInit($event)"></div>
        </div>
    </div>
</div>
